export default __webpack_public_path__ + "static/media/watermarkBL.3c61bee2.png";